import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({
  name: 'currencyCents',
  standalone: false,
})
export class CurrencyCentsPipe extends CurrencyPipe implements PipeTransform {
  // If we need more flexibility we can always do something like https://stackoverflow.com/a/41224814
  override transform(value: any,
            currencyCode: string = 'CAD',
            display:
              | 'code'
              | 'symbol'
              | 'symbol-narrow'
              | string
              | boolean = 'symbol-narrow',
            digitsInfo: string = '1.2-2',
            locale: string = 'fr-CA'): any {
    if (value === null || value === undefined) {
      return value;
    }
    value = value / 100;
    return super.transform(value, currencyCode, display, digitsInfo, locale);
  }
}